var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"text-caption__container"},[_c('div',{staticClass:"text-caption__name-tag",style:({ display: _vm.nameTag === '' ? 'none' : 'flex' })},[_c('div',[_vm._v(_vm._s(_vm.nameTag))])]),_c('div',{attrs:{"id":"typewriter"}})])
}
var staticRenderFns = []

export { render, staticRenderFns }